<script setup>
defineProps({
	items: {
		type: Array,
		required: true,
		validator (items) {
			if (!items.length) {
				return true;
			}
			const [itemToTest] = items;
			return ('value' in itemToTest && 'text' in itemToTest);
		}
	},
	ariaLabel: {
		type: String,
		required: true
	}
});

const selected = defineModel('selected', {
	type: Number,
	default: 0
});
</script>

<template>
  <div class="selectbox selectbox--grayBorder filter-paymentmethod">
    <select
      v-model="selected"
      class="select select--decoration"
      :aria-label="ariaLabel"
    >
      <option
        v-for="item in items"
        :key="item.value"
        :value="item.value"
      >
        <slot>
          {{ item.text }}
        </slot>
      </option>
    </select>
  </div>
</template>
